module.exports = __webpack_public_path__ + "static/media/banner.af64de70.jpg";